if (!customElements.get('card-variant-add')) {
  customElements.define(
    'card-variant-add',
    class CardVariantAdd extends HTMLElement {
      connectedCallback() {
        this.options = this.querySelectorAll('.card-variant-add__option');
        this.formWrap = this.querySelector('.card-variant-add__form-wrap');
        this.variantInput = this.querySelector('.product-variant-id');
        this.submitButton = this.querySelector('.card-variant-add__submit');
        this.submitLabel = this.submitButton?.querySelector('span');
        this.addLabel = this.dataset.addLabel || this.submitLabel?.textContent?.trim() || 'Add to cart';
        this.soldOutLabel = this.dataset.soldOutLabel || 'Sold out';

        this.options.forEach((button) => {
          button.addEventListener('click', this.onOptionClick.bind(this));
        });
      }

      onOptionClick(event) {
        const button = event.currentTarget;
        if (button.getAttribute('aria-disabled') === 'true') return;

        this.options.forEach((option) => {
          option.setAttribute('aria-selected', option === button ? 'true' : 'false');
        });

        const variantId = button.dataset.variantId;
        const available = button.dataset.available === 'true';

        if (this.formWrap) this.formWrap.hidden = false;

        if (this.variantInput) {
          this.variantInput.value = variantId;
          this.variantInput.disabled = false;
        }

        if (this.submitButton) {
          this.submitButton.disabled = !available;
          if (available) {
            this.submitButton.removeAttribute('aria-disabled');
          } else {
            this.submitButton.setAttribute('aria-disabled', 'true');
          }
        }

        if (this.submitLabel) {
          this.submitLabel.textContent = available ? this.addLabel : this.soldOutLabel;
        }
      }
    }
  );
}